const AUTH_TOKEN_STORAGE_KEY = 'promptlab.registry.authToken';
const AUTH_REMEMBER_ME_STORAGE_KEY = 'promptlab.registry.rememberMe';

const getStorage = (rememberMe: boolean): Storage | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return rememberMe ? window.localStorage : window.sessionStorage;
};

export const getRememberMePreference = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.localStorage.getItem(AUTH_REMEMBER_ME_STORAGE_KEY) === 'true';
};

export const getAuthToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) || window.sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
};

export const setAuthToken = (token: string | null, rememberMe: boolean = getRememberMePreference()) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  window.sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);

  if (!token) {
    window.localStorage.removeItem(AUTH_REMEMBER_ME_STORAGE_KEY);
    return;
  }

  window.localStorage.setItem(AUTH_REMEMBER_ME_STORAGE_KEY, rememberMe ? 'true' : 'false');
  getStorage(rememberMe)?.setItem(AUTH_TOKEN_STORAGE_KEY, token);
};
